import { UseAxiosResult } from "axios-hooks";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { UseSelectUserManagementApi } from "./setup";

export interface LoginSetting {
  displayName: string;
  name: string;
  isThirdParty: boolean;
}

export const loginSettingsQuery = (
  inviteId: string | undefined
): UseAxiosResult<LoginSetting[]> => {
  return UseSelectUserManagementApi<LoginSetting[]>({
    url: api.login.settings,
    method: "GET",
    params: { inviteId },
  });
};

export interface LoginByPasswordProps {
  email: string;
  password: string;
  rememberMe: boolean;
  redirectUrl: string;
}

export interface UserLoginRedirect {
  loginRedirect: string;
}

export const loginByPasswordMutation =
  (): UseAxiosResult<UserLoginRedirect> => {
    return UseSelectUserManagementApi<UserLoginRedirect>(
      {
        url: formatUrl(api.login.byPassword),
        method: "POST",
      },
      {
        manual: true,
      }
    );
  };

export const checkInviteValidate = (): UseAxiosResult => {
  return UseSelectUserManagementApi(
    {
      url: formatUrl(api.login.byPassword),
      method: "GET",
    },
    {
      manual: true,
    }
  );
};
